@if (showDebug$ | async; as showDebug) {
  <div class="conferencing-subscription-indicator">
    @if (conferencingSubscription$ | async; as conferencingSubscription) {
      <mat-icon
        svgIcon="cm:phone-call"
        [ngClass]="conferencingSubscription.connected === true ? 'success' : 'error'"
      ></mat-icon>
    }
  </div>
}
